import React from "react";
import { Modal } from "sprint-common-web";

import { LookupCloudAssetItem } from "./LookupCloudAssetItem";
import { LookupCloudAssetsList } from "./LookupCloudAssetsList";

type LookupCloudAssetsModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onClick: (item: LookupCloudAssetItem) => void;
};

export const LookupCloudAssetsModal = ({ isOpen, onClick, onClose }: LookupCloudAssetsModalProps): JSX.Element => {
    return (
        <Modal isOpen={isOpen} headerText="Lookup cloud assets" onDismiss={onClose} size="lg" displayCloseButton={true}>
            <LookupCloudAssetsList onClick={onClick} />
        </Modal>
    );
};
